<template>
  <div class="info">
    <div class="headline-container">
      <span class="info-order-id"
        >Digital-Order-ID:
        <span class="bold">{{
          this.$store.state.subscription.order_id
        }}</span></span
      >
      <span class="info-thx">
        Thank you {{ this.$store.state.subscription.firstname }}
        {{ this.$store.state.subscription.lastname }}!
      </span>
    </div>

    <span class="info-complete">
      <span>Your order is completed</span>
      <br />
      <span class="email-hint"
        >An e-mail with the invoice was sent to the e-mail address provided.</span
      >
      <span class="manage-link">
        <span>You can manage your subscription at:</span>
        <a
          target="_blank"
          v-bind:href="
            'https://subscriptions.solar-fox.com/subscription/info?customer_id=' +
              this.$router.history.current.query.customer_id +
              '&order_id=' +
              this.$router.history.current.query.order_id +
              '&subscription_access_token=' +
              this.$router.history.current.query.subscription_access_token
          "
          >subscriptions.solar-fox.com</a
        >
      </span>
    </span>

    <customer-info-view />
  </div>
</template>

<script>
import CustomerInfoView from "@/components/Order/CustomerInfo.vue";

export default {
  name: "info-view",
  props: {
    title: String,
  },
  components: {
    "customer-info-view": CustomerInfoView,
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.headline-container {
  display: flex;
  flex-direction: column;
}

.info-complete {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 15px;
  margin-top: 35px;
  font-size: 18px;
}

.info-thx {
  font-size: 20px;
  margin-top: 10px;
}

.bold {
  font-weight: bold;
}
.email-hint {
  font-size: 14px;
  display: flex;
  margin-top: 10px;
}
.manage-link span {
  margin-right: 5px;
}

.manage-link {
  font-size: 14px;
  display: flex;
  margin-top: 10px;
}

@media print {
  .headline-container,
  .info-complete {
    display: none;
  }
}
</style>
